import { createSelector, createFeatureSelector } from '@ngrx/store';
import { DoubtsState } from '../reducers/doubts.reducer';

export const selectDoubtsState =
  createFeatureSelector<DoubtsState>('doubtsData');

export const selectSelectedDoubtId = createSelector(
  selectDoubtsState,
  (state: DoubtsState) => state.selectedDoubtId
);

export const selectSelectedDoubt = createSelector(
  selectDoubtsState,
  selectSelectedDoubtId,
  (state: DoubtsState, doubtId: string) =>
    state.data.find((doubt) => doubt.id === doubtId)
);
